import { render, staticRenderFns } from "./NavRoute.vue?vue&type=template&id=6b403d4c&functional=true&"
import script from "./NavRoute.vue?vue&type=script&lang=js&"
export * from "./NavRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports